<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_Quot_Supplys' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txQuotSupplys">
      <div class="bg-white fh" id='txQuotSupplys-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txQuotSupplys-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="editcrmType"
                     createdFormId="txQuotSupplys-dialog"
                     :visible.sync="dialogEditVisible"
                     :otherSubmitModel="otherSubmitModel"
                     :initData="temp">
      </edit-instance>

      <edit-instance ref="confirmeditForm" :sourceCode="confirmcrmType"
                     createdFormId="txQuotSupplys-dialog"
                     :visible.sync="dialogconfirmEditVisible"
                     :initData="confirmtemp">
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as txQuotSupplys from '@/api/tx_quot_supplys';
import mytable from '@/utils/crmtableFlowV2';

export default {
  name: 'txQuotSupplys',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_Quot_Supply',
      editcrmType: 'Tx_Quot_Supply',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {},
      confirmcrmType: 'Tx_OfficialTime',
      dialogconfirmEditVisible: false,
      confirmtemp: {},
      otherSubmitModel: {}
    };
  },
  created() {
    const _this = this;
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
    this.otherSubmitModel = {
      othersub() {
        return _this.othersub();
      }
    };
  },
  methods: {
    getApi() {
      if (this.dialogconfirmEditVisible) {
        return {
          update: (data) => {
            return txQuotSupplys.Confirm(data);
          }
        };
      } else {
        return txQuotSupplys;
      }
    },
    othersub() {
      return new Promise((resolve, reject) => {
        const temp = this.$refs[this.dataForm].$refs[this.frmData].GetModelData();
        const totalPriceArray = [];
        if (temp.orderDetail && temp.orderDetail.length > 0) {
          temp.orderDetail.forEach((item, index) => {
            if (item.totalPrice === 0) {
              totalPriceArray.push(index);
            }
          });
          if (totalPriceArray.length === temp.orderDetail.length) {
            this.$message.error('供应商报价必须大于零');
            reject(new Error());
          }
          const lock = temp.orderDetail.filter((item) => {
            return item.totalPrice !== 0;
          }).some((item) => {
            return item.dtOfDelivery === 0 || item.invTaxRate === 0;
          });
          if (lock) {
            this.$message.error('请填写交货期或税率');
            reject(new Error());
          }

          return resolve(true);
        } else {
          reject(new Error());
        }
      });
    },
    handleUpdate(row) { // 弹出编辑框
      this.getApi().get(row.id).then(response => {
        this.temp = response.result == null ? {} : response.result;
        if (this.temp.quotState === '二次报价') {
          this.editcrmType = 'Tx_Quot_Supply2';
        } else {
          this.editcrmType = 'Tx_Quot_Supply';
        }
        this.dialogStatus = 'update';
        this.dialogEditVisible = true;
      });
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnRetract':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Retract(this.multipleSelection[0]);
          }
          break;
        case 'btnConfirm':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Confirm();
          }
          break;
      }
    },
    Confirm() {
      this.getApi().get(this.multipleSelection[0].id).then(response => {
        this.confirmtemp = response.result == null ? {} : response.result;
        this.dialogStatus = 'update';
        this.dialogconfirmEditVisible = true;
      });
    },
    Retract(row) {
      const conforms = row.state === '已报价' && (row.quotState === '询价中' || row.quotState === '二次报价');
      this.listLoading = true;
      if (conforms) {
        txQuotSupplys.Back(row.id).then(res => {
          this.$message({
            message: '撤回成功',
            type: 'success'
          });
          this.dialogForwardVisible = false;
          this.getList();
        }).catch((_) => {
          this.dialogForwardVisible = false;
        });
      } else {
        this.$message({
          message: '请选择状态为已报价，询价中或二次报价的数据!',
          type: 'error'
        });
        this.getList();
      }
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txQuotSupplys') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'tx_quot_supplysview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txQuotSupplys-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

.txQuotSupplys .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txQuotSupplys .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}
</style>
